require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/top-message/main-top-message.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/top-message/main-top-message.legacy.js
// module id = 682
// module chunks = 31